import store from '@state/store'


// auth related routes
const authRoutes = [
  {
    path: '/noauth',
    name: 'noauth',
    props: (route) => ({ name: route.query.name }),
    component: () => lazyLoadView(import('@views/pages/start')),
  },
  {
    path: '/oauth2/login',
    name: 'oauth2',
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    props: (route) => ({ code: route.query.code }),
    component: () => lazyLoadView(import('@views/pages/auth/oauth')),
    // store.commit('SET_CURRENT_USER', { token: validUserExample.token })

    // meta: {
    //   beforeResolve(routeTo, routeFrom, next) {

    //     // If the user is already logged in
    //     if (store.getters['auth/loggedIn']) {
    //       // Redirect to the home page instead
    //       next({ name: 'dashboard' })
    //     } else {
    //       // Continue to the login page
    //       next()
    //     }
    //   },
    // },
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => lazyLoadView(import('@views/pages/account/register')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'dashboard' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  // {
  //   path: '/confirm-account',
  //   name: 'confirm-account',
  //   component: () => lazyLoadView(import('@views/pages/account/confirm')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'dashboard' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  // {
  //   path: '/forget-password',
  //   name: 'forget-password',
  //   component: () =>
  //     lazyLoadView(import('@views/pages/account/forgetPassword')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'dashboard' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  // {
  //   path: '/logout',
  //   name: 'logout',
  //   meta: {
  //     authRequired: true,
  //     beforeResolve(routeTo, routeFrom, next) {
  //       store.dispatch('auth/logOut')
  //       const authRequiredOnPreviousRoute = routeFrom.matched.some(
  //         (route) => route.meta.authRequired
  //       )
  //       // Navigate back to previous page, or home as a fallback
  //       next(
  //         authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
  //       )
  //     },
  //   },
  // },
]

// auth related routes
// const authRoutes = [
//   {
//     path: '/login',
//     name: 'login',
//     component: () => lazyLoadView(import('@views/pages/account/login')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/register',
//     name: 'register',
//     component: () => lazyLoadView(import('@views/pages/account/register')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/confirm-account',
//     name: 'confirm-account',
//     component: () => lazyLoadView(import('@views/pages/account/confirm')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/forget-password',
//     name: 'forget-password',
//     component: () =>
//       lazyLoadView(import('@views/pages/account/forgetPassword')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/logout',
//     name: 'logout',
//     meta: {
//       authRequired: true,
//       beforeResolve(routeTo, routeFrom, next) {
//         store.dispatch('auth/logOut')
//         const authRequiredOnPreviousRoute = routeFrom.matched.some(
//           (route) => route.meta.authRequired
//         )
//         // Navigate back to previous page, or home as a fallback
//         next(
//           authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
//         )
//       },
//     },
//   },
// ]

// error pages
const errorPagesRoutes = [
  {
    path: '/404',
    name: '404',
    component: require('@views/pages/secondary/error-404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/500',
    name: '500',
    component: require('@views/pages/secondary/error-500').default,
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    props: (route) => ({ code: route.query.code }),
    component: () => lazyLoadView(import('@views/pages/frontdoor')),
    meta: { requiresAuth: false },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    header: 'General',
    icon: 'home',
    // badge: {
    //   text: '1',
    //   varient: 'success',
    // },
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    props: (route) => ({ name: route.query.name }),
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
  },
]

// dashboard
const panReport = [
  {
    path: '/',
    props: (route) => ({ code: route.query.code }),
    component: () => lazyLoadView(import('@views/pages/frontdoor')),
    meta: { requiresAuth: false },
  },
  {
    path: '/report/general',
    name: 'General',
    header: 'Reportes',
    icon: 'briefcase',
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    props: (route) => ({ name: route.query.name }),
    component: () => lazyLoadView(import('@views/pages/dashboard/general_report')),
  },
]

// incidents
const incidentsAllRoutes = [
  {
    path: '/incidents/all',
    name: 'All Incidents',
    header: 'Incidents',
    icon: 'eye',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/incidents/all')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const incidentsSearchRoutes = [
    {
      path: '/incidents/lists',
      name: 'Filtered',
      icon: 'search',
      meta: { requiresAuth: true },
      component: {
        render(c) {
          return c('router-view')
        },
      },
      // props: (route) => ({ user: store.state.auth.currentUser || {} }),
      children: [
        {
          name: 'Open',
          path: 'open',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/open')),
        },
        {
          name: 'Closed',
          path: 'closed',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/closed')),
        },
        {
          name: 'False Positives',
          path: 'false_positives',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/false_positives')),
        },
        {
          name: 'Handled',
          path: 'handled',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/handled')),
        },
        {
          name: 'Other',
          path: 'other',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/other')),
        },
      ],
    }
  ];

const incidentsCreateRoutes = [
  {
    path: '/apps/email',
    name: 'Add',
    icon: 'plus',
    meta: { requiresAuth: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: 'Inbox',
        path: 'inbox',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/email/inbox')),
      },
      {
        path: 'read',
        name: 'Read Email',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/email/reademail')),
      },
      {
        path: 'compose',
        name: 'Compose Email',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/email/emailcompose')),
      },
    ],
  }
];

const incidentsTriageRoutes = [
  {
    path: '/incidents/triage',
    name: 'Triage',
    icon: 'alert-triangle',
    meta: { requiresAuth: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'unassigned',
        name: 'Unassigned',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/incidents/triage')),
      },
    ],
  }
];

const incidentsRoutes = [
  ...incidentsAllRoutes,
  ...incidentsSearchRoutes,
  // ...incidentsTriageRoutes,
  // ...incidentsCreateRoutes
]

const alertsAllRoutes = [
  {
    path: '/alerts/all',
    name: 'All Alerts',
    header: 'Alerts',
    icon: 'bell',
    component: () => lazyLoadView(import('@views/pages/apps/alerts/all')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];


const alertsGroupedRoutes = [
  {
    path: '/alerts/grouped',
    name: 'Grouped',
    icon: 'grid',
    header: 'Alerts',
    component: () => lazyLoadView(import('@views/pages/apps/alerts/grouped')),
    meta: { requiresAuth: true },
  }
];

const alertsRoutes = [
  // ...alertsAllRoutes,
  ...alertsGroupedRoutes,
]

const actionsRoutes = [
  {
    path: '/actions/view',
    name: 'View Actions',
    header: 'Actions',
    icon: 'settings',
    component: () => lazyLoadView(import('@views/pages/apps/assets/all')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

// assets

const suspectAssetsRoutes = [
  {
    path: '/assets/suspects',
    name: 'Suspects',
    header: 'Assets',
    icon: 'alert-octagon',
    component: () => lazyLoadView(import('@views/pages/apps/assets/suspects')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const isolatedAssetsRoutes = [
  {
    path: '/assets/isolated',
    name: 'Isolated',
    icon: 'minimize',
    component: () => lazyLoadView(import('@views/pages/apps/assets/isolated')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const allAssetsRoutes = [
  {
    path: '/assets/all',
    name: 'All Assets',
    icon: 'package',
    component: () => lazyLoadView(import('@views/pages/apps/assets/all')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const assetsRoutes = [
  ...suspectAssetsRoutes,
  // ...isolatedAssetsRoutes,
  ...allAssetsRoutes,
]
// indicators

const allIndicatorsRoutes = [
  {
    path: '/indicators/all',
    name: 'All Indicators',
    icon: 'package',
    header: 'Indicators',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/all')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const dangerousIndicatorsRoutes = [
  {
    path: '/indicators/dangerous',
    name: 'Dangerous',
    icon: 'alert-octagon',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/dangerous')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const intelIndicatorsRoutes = [
  {
    path: '/indicators/intel',
    name: 'Intelligence',
    icon: 'crosshair',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/intel')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const indicatorsRoutes = [
    ...allIndicatorsRoutes,
  ...dangerousIndicatorsRoutes,
  ...intelIndicatorsRoutes,
  // ...allIndicatorsRoutes,
]


// services
const reportCustomMDRRoute = [
  {
    path: '/reports/mdr/custom',
    name: 'MDR General',
    icon: 'file',
    header: 'Reports',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/general_report_mdr')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const reportByCompanyMDRRoute = [
  {
    path: '/reports/mdr/bycompany',
    name: 'MDR By Company',
    icon: 'briefcase',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/by_company_report_mdr')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const reportGeneralOffice365Route = [
  {
    path: '/reports/office365/general',
    name: 'Office365',
    icon: 'package',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/general_report_office365')),
  },
]

const reportGeneralPANRoute = [
  {
    path: '/reports/pan/general',
    name: 'PAN NGFW',
    icon: 'globe',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/general_report_pan')),
  },
]

const reportRoutes = [
  ...panReport,
  // ...reportCustomMDRRoute,
  // ...reportByCompanyMDRRoute,
  // ...reportGeneralOffice365Route,
  // ...reportGeneralPANRoute
]

// services
const serviceAlertsRoutes = [
  {
    path: '/service/alerts',
    name: 'Alerts',
    icon: 'bell',
    header: 'Service',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/service/alerts')),
  },
]

const serviceStatusRoutes = [
  {
    path: '/service/sla',
    name: 'SLA',
    icon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/service/sla')),
  },
]

const serviceLevelObjectivesRoutes = [
  {
    path: '/service/slo',
    name: 'SLO',
    icon: 'briefcase',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/service/slo')),
  },
]

const serviceRoutes = [
  ...serviceAlertsRoutes,
  ...serviceStatusRoutes,
  ...serviceLevelObjectivesRoutes,
]

// recommendations
const recommendationAllRoutes = [
  {
    path: '/recommendations/all',
    name: 'Todas',
    icon: 'coffee',
    header: 'Recomendaciones',
    meta: { requiresAuth: true, requiresUserGroups: ["360"] },
    // meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/recommendations/all')),
  },
  {
    path: '/recommendations/client/all',
    name: 'Todas',
    icon: 'coffee',
    header: 'Recomendaciones',
    meta: { requiresAuth: true, requiresUserGroups: ["cliente"] },
    component: () => lazyLoadView(import('@views/pages/dashboard/recommendations')),
  },
]

const recommendationFilteredRoutes = [
  {
    path: '/recommendations/filtered',
    name: 'Filtered',
    icon: 'coffee',
    meta: { requiresAuth: true, requiresUserGroups: ["360"] },
    component: () => lazyLoadView(import('@views/pages/apps/recommendations/filtered')),
  },
]

const recommendationsRoutes = [
  ...recommendationAllRoutes,
]


// tables
// const tablesRoutes = [
//   {
//     path: '/tables',
//     name: 'Tables',
//     icon: 'grid',
//     meta: { authRequired: true },
//     // create a container component
//     component: {
//       render(c) {
//         return c('router-view')
//       },
//     },
//     children: [
//       {
//         path: 'basic',
//         name: 'Basic Tables',
//         component: () =>
//           lazyLoadView(import('@views/pages/ui/tables/basic-table')),
//       },
//       {
//         path: 'advanced',
//         name: 'Advanced Tables',
//         component: () =>
//           lazyLoadView(import('@views/pages/ui/tables/advanced-table')),
//       },
//     ],
//   },
// ]

// // charts
// const chartsRoutes = [
//   {
//     path: '/charts',
//     name: 'Charts',
//     icon: 'pie-chart',
//     component: () => lazyLoadView(import('@views/pages/ui/chart/')),
//     meta: { authRequired: true },
//     props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   },
// ]

const dataNetworksRoutes = [
  {
    path: '/data/networks',
    name: 'Networks',
    icon: 'globe',
    header: 'Data',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/data/all_networks')),
  },
]

const dataRoutes = [
  ...dataNetworksRoutes,
]

const office365EventsRoutes = [
  {
    path: '/office365/events',
    name: 'Events',
    icon: 'sun',
    header: 'Office 365',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/office365/all_events')),
  },
]

const office365EventsAlarms = [
  {
    path: '/office365/events/alarms',
    name: 'Alarms',
    icon: 'bell',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/office365/all_alarms')),
  },
]

const office365Routes = [
  ...office365EventsRoutes,
  ...office365EventsAlarms
]
const authProtectedRoutes = [
  ...dashboardRoutes,
  // ...incidentsRoutes,
  // ...alertsRoutes,
  // ...assetsRoutes,
  // ...indicatorsRoutes,
  ...reportRoutes,
  // ...serviceRoutes,
  ...recommendationsRoutes,
  // ...dataRoutes,
  // ...office365Routes
]
const allRoutes = [...authRoutes, ...authProtectedRoutes, ...errorPagesRoutes]
// const allRoutes = [...authProtectedRoutes, ...errorPagesRoutes]

export { allRoutes, authProtectedRoutes }

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@components/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
